import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { iterable } from '@/utils/array';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HealthBar',
  props: {
    value: null,
    levelMaximums: null
  },
  setup(__props: any) {

const props = __props as {
  value: number;
  levelMaximums: number[];
};



const { t } = useI18n();

function isLevelFullyFilled(index: number): boolean {
  if (index === props.levelMaximums.length - 1) {
    return true;
  }
  return props.value >= props.levelMaximums[index];
}

function getLevelSegmentValue(index: number): number {
  //   value  index
  // [##    |      | ]
  if (isValueInPreviousSegment(index)) {
    return 0;
  }
  //      value index
  // [##|##          ]
  if (isValueInSegment(index)) {
    return props.value - levelStartValues.value[index];
  }
  //          index  value
  // [######|#######|#    ]
  return levelSizes.value[index];
}

function isValueInPreviousSegment(index: number) {
  return props.value < levelStartValues.value[index];
}

function isValueInSegment(index: number) {
  return (
    !isValueInPreviousSegment(index) &&
    props.value <= props.levelMaximums[index]
  );
}

function getBoundarySegmentValue(index: number): number {
  if (
    props.value > levelStartValues.value[index] &&
    props.value <= props.levelMaximums[index]
  ) {
    return props.levelMaximums[index] - props.value;
  }
  return levelSizes.value[index];
}

function getBoundaryPositionClass(newValue: number): string {
  const valuePercentage = max.value !== 0 ? (newValue * 100) / max.value : 0;
  // value may be greater than the E level maximum, so limit it to 100 % with min.
  return `left-${Math.min(Math.round(valuePercentage), 100)}`;
}

function getRoundSegmentEndLeftPosition(index: number) {
  const value = iterable(index + 1)
    .map((n) => getLevelSegmentValue(n))
    .reduce((a, b) => a + b, 0);
  return getBoundaryPositionClass(value);
}

const max = computed<number>(() => Math.max(...props.levelMaximums));

const levelSizes = computed<number[]>(() =>
  props.levelMaximums.map((levelMaximum, index) =>
    index === 0 ? levelMaximum : levelMaximum - props.levelMaximums[index - 1],
  ),
);

const levelStartValues = computed<number[]>(() =>
  props.levelMaximums.map((_, index) =>
    index === 0 ? 0 : props.levelMaximums[index - 1],
  ),
);

const valueLevelIndex = computed<number>(() => {
  const eLevelMaximum = props.levelMaximums[props.levelMaximums.length - 1];
  // This condition may happen, so adjust the value for findIndex to work.
  const adjustedValue =
    props.value <= eLevelMaximum ? props.value : eLevelMaximum;
  return props.levelMaximums.findIndex(
    (levelMaximum) => adjustedValue <= levelMaximum,
  );
});

const tooltipLabel = computed<string>(
  () => ['A', 'B', 'C', 'D', 'E'][valueLevelIndex.value],
);

const boundaryPositionClass = computed<string>(() =>
  getBoundaryPositionClass(props.value),
);

const hasData = computed<boolean>(
  () =>
    props.levelMaximums.some((levelMaximum) => levelMaximum !== 0) ||
    props.value !== 0,
);

return { __sfc: true,props, t, isLevelFullyFilled, getLevelSegmentValue, isValueInPreviousSegment, isValueInSegment, getBoundarySegmentValue, getBoundaryPositionClass, getRoundSegmentEndLeftPosition, max, levelSizes, levelStartValues, valueLevelIndex, tooltipLabel, boundaryPositionClass, hasData }
}

})